import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

import { AuthStore } from '@/core/auth.store';
import { resolvePanelHomePath } from '@/core/panel-permissions';

@Component({
    selector: 'app-access',
    standalone: true,
    imports: [RouterLink],
    template: `
        <section class="animate-fadein animate-duration-300 animate-ease-in landing-container mx-auto min-h-[75vh] lg:min-h-screen flex flex-col items-center justify-center">
            <h1 class="title-h5 lg:title-h1 mt-8">Acesso negado</h1>
            <p class="body-small lg:body-large mt-2 lg:mt-4">Você não tem permissão para acessar esta página</p>
            <a
                [routerLink]="homePath"
                class="body-button bg-violet-600 w-fit mt-8 hover:bg-violet-500 px-4"
                >Ir para o início</a
            >
        </section>
    `
})
export class Access {
    private readonly authStore = inject(AuthStore);

    readonly homePath = resolvePanelHomePath((permission) => this.authStore.can(permission));
}
